const axios = require("axios");
import { config } from "assets/config.js";
import store from "@/store";
import router from "@/router";

function DMApi(apiUrl, data, throwError, headers) {
  data = data || {};
  throwError = throwError || false;
  var configParam = { crossdomain: true };
  if (headers) {
    configParam.headers = headers;
  }
  return axios
    .post(apiUrl, data, configParam)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else throw error;
    });
}
function getAPI(endpoint, params, throwError, headers) {
  params = params || {};
  throwError = throwError || false;
  var api = config.restApiURL;
  if (!PRODUCTION) api = config.devRestApiURL; // eslint-disable-line
  var url = api + endpoint;
  return axios
    .get(url, {
      crossdomain: true,
      params,
      headers: headers || {}
    })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else throw error;
    });
}

function postAPI(endpoint, data, throwError, headers) {
  data = data || {};
  throwError = throwError || false;
  var api = config.restApiURL;
  if (!PRODUCTION) api = config.devRestApiURL; // eslint-disable-line
  var url = api + endpoint;
  var configParam = { crossdomain: true };
  if (headers) {
    configParam.headers = headers;
  }
  return axios
    .post(url, data, configParam)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else throw error;
    });
}

function putAPI(endpoint, data = {}, throwError = false, headers) {
  const api = PRODUCTION // eslint-disable-line
    ? config.restApiURL
    : config.devRestApiURL;
  const configParam = {
    crossdomain: true,
    headers,
  };
  return axios
    .put(api + endpoint, data, configParam)
    .then(response => response.data)
    .catch(error => {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else {
        throw error;
      }
    });
}

function getDownloadAPI(endpoint, params, throwError) {
  params = params || {};
  throwError = throwError || false;
  var api = config.restApiURL;
  if (!PRODUCTION) api = config.devRestApiURL; // eslint-disable-line
  var url = api + endpoint;
  return axios
    .get(url, {
      crossdomain: true,
      responseType : 'blob',
      params
    })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else throw error;
    });
}

function postDownloadAPI(endpoint, data, throwError, headers) {
  data = data || {};
  throwError = throwError || false;
  var api = config.restApiURL;
  if (!PRODUCTION) api = config.devRestApiURL; // eslint-disable-line
  var url = api + endpoint;
  var configParam = { crossdomain: true, responseType : 'blob', };
  if (headers) {
    configParam.headers = headers;
  }
  return axios
    .post(url, data, configParam)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      if (!throwError && error.response && error.response.status == 401) {
        //Stop other "threads":
        window.stop();
        document.execCommand("Stop");

        store.set("global/redirectTo", router.currentRoute);
        router.push("/login");
      } else throw error;
    });
}

export { getAPI, postAPI, putAPI, DMApi, getDownloadAPI, postDownloadAPI };
